import React from "react";
import { useTranslation } from "react-i18next";
import { InfoBanner } from "@services/ui-components";

export const TranslationLockedFieldsInfoBanner = () => {
    const { t } = useTranslation();

    return (
        <InfoBanner
            positionIcon="start"
            backgroundColor="additional-grey"
            textColor="dark"
            marginClasses="mb-3"
            className="py-6"
            iconStyle={{ marginTop: 2 }}
        >
            <p className="fs-7 mb-0">
                {t(
                    "To edit locked fields, switch to the primary language" +
                        " version in the Language version selector."
                )}
            </p>
        </InfoBanner>
    );
};
